class BibleBuy extends HTMLElement {
    constructor() {
        super();
        this.originalCart = null;
        this.buyNowBtn=this.querySelector('.buyNowBtn');
        this.variantId=this.getAttribute('data-variantId');
        // console.log("data-variantId",this.variantId);
        this.addEventListener('click', (e) => {
            
            e.preventDefault();
            this.initCheckout(this.variantId);
        });
    }
    async initCheckout(productVariantId) {
        // console.log("initCheckout",productVariantId);
        // await this.saveOriginalCart();
        // await this.clearCart();
        this.buyNowBtn.classList.add('loading');
        this.buyNowBtn.querySelector('.btn-text').style.opacity = '0';
        this.buyNowBtn.querySelector('.btn-loader').style.display = 'inline-block';
        this.buyNowBtn.disabled = true;
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'bible_buy',
            variantId: productVariantId
        });
        await this.addToCart(productVariantId);
        window.location.href = '/checkout';
    }
    
    async saveOriginalCart() {
        const response = await fetch('/cart.js');
        this.originalCart = await response.json();
        localStorage.setItem('originalCart', JSON.stringify(this.originalCart));
    }
    
    async restoreOriginalCart() {
        const savedCart = localStorage.getItem('originalCart');
        if (savedCart) {
        }
    }
    
    async clearCart() {
        await fetch('/cart/clear.js', { method: 'POST' });
    }
    
    async addToCart(variantId) {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: [{ id: variantId, quantity: 1 }]
            })
        });
    }
    
}
if (!customElements.get('bible-buy')) {
    customElements.define('bible-buy', BibleBuy);
}
